import React from "react";
import GridImage from "../../../../assets/images/png/grids/image1.webp";
import * as Animate from "react-reveal";

const ImageSection = ({ image1, image2, image3, image4 }) => {
  return (
    <section className="relative w-full">
      <Animate.Fade bottom>
        <div
          className="grid grid-cols-2 lg:grid-cols-4"
          style={{ fontSize: 0 }}
        >
          <img src={image1 || GridImage} alt="" />
          <img src={image2 || GridImage} alt="" />
          <img src={image3 || GridImage} alt="" />
          <img src={image4 || GridImage} alt="" />
        </div>
      </Animate.Fade>
    </section>
  );
};

export default ImageSection;
